import { render, staticRenderFns } from "./PricingQC.vue?vue&type=template&id=158f7910&"
import script from "./PricingQC.vue?vue&type=script&lang=js&"
export * from "./PricingQC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports